<template>
  <div class="hgroup">
    <h2 class="c-title-level2">
      월별 매입 현황<small class="main-small">(해당 월 기준 1년)</small>
    </h2>
    <!-- 250408 타이틀 수정 -->
    <a
      href="javascript:void(0);"
      class="c-readmore type-round"
      @click="routerCmd()"
    >
      <i class="c-icon icon-plus-black size-xsmall"></i>
      <span class="text">자세히보기</span>
      <!-- 250408 텍스트 수정 -->
    </a>
  </div>

  <div v-if="isMobile" class="month-aggregated">
    <!-- D:
			1. 증가: is-increase
			2. 감소: is-decreased
			3. 동일: is-unchanged
		-->
    <!-- 250408 영역 수정// -->
    <div class="left-tit">
      <span v-if="data.chart.flag == 'A'" class="compared is-decreased"
        >전월대비 {{ data.chart.cnt02 }}원 감소</span
      >
      <span v-if="data.chart.flag == 'B'" class="compared is-unchanged"
        >전월대비 동일</span
      >
      <!-- 필요하면 추가 : {{ data.chart.cnt02 }}원  -->
      <span v-if="data.chart.flag == 'C'" class="compared is-increase"
        >전월대비 {{ data.chart.cnt02 }}원 증가</span
      >

      <span class="last-month">{{ data.chart.getMonth }}월 매입금액</span>
    </div>
    <!-- //250408 영역 수정 -->
    <span class="result">
      <span class="system">{{ data.chart.cnt01 }}</span
      >원
    </span>
  </div>

  <div class="chart-box">
    <Bar :data="data.chart.chartData" :options="data.options"></Bar>
  </div>

  <div v-if="!isMobile" class="month-aggregated">
    <!-- D:
			1. 증가: is-increase
			2. 감소: is-decreased
			3. 동일: is-unchanged
		-->
    <!-- 250408 영역 수정// -->
    <div class="left-tit">
      <span v-if="data.chart.flag == 'A'" class="compared is-decreased"
        >전월대비 {{ data.chart.cnt02 }}원 감소</span
      >
      <span v-if="data.chart.flag == 'B'" class="compared is-unchanged"
        >전월대비 동일</span
      >
      <!-- 필요하면 추가 : {{ data.chart.cnt02 }}원  -->
      <span v-if="data.chart.flag == 'C'" class="compared is-increase"
        >전월대비 {{ data.chart.cnt02 }}원 증가</span
      >

      <span class="last-month">{{ data.chart.getMonth }}월 매입금액</span>
    </div>
    <!-- //250408 영역 수정 -->
    <span class="result">
      <span class="system">{{ data.chart.cnt01 }}</span
      >원
    </span>
  </div>
</template>

<script setup name="BarChart">
import { defineProps, reactive, watch } from "vue";

import { Bar } from "vue-chartjs";
import { useRouter } from "vue-router";
import * as cmUtil from "@/utils/cmUtil.js";
const { isMobile } = cmUtil.useDeviceType();

const router = useRouter();

import {
  Chart as ChartJS,
  Title,
  Tooltip,
  Legend,
  BarElement,
  CategoryScale,
  LinearScale,
} from "chart.js";

ChartJS.register(
  Title,
  Tooltip,
  Legend,
  BarElement,
  CategoryScale,
  LinearScale
);

const props = defineProps({
  data: {
    type: Object,
    required: true,
  },
});

const data = reactive({
  chart: {
    type: "bar",
    year: [],
    getMonth: "", //현재 월
    cnt01: "", //현재 월 매입금액
    cnt02: "", //현재 월 - 전 월 매입금액
    flag: "", //전월대비 감소/동일/증가 표기
    chartData: {
      labels: [],
      datasets: [
        {
          data: [],
          backgroundColor: (context) => {
            return context.dataIndex === context.dataset.data.length - 1
              ? "#007D6C"
              : "#C8EFE5";
          },
          hoverBackgroundColor: (context) => {
            return context.dataIndex === context.dataset.data.length - 1
              ? "#007D6C"
              : "#C8EFE5";
          },
          borderRadius: 30,
          barThickness: 20,
        },
      ],
    },
  },
  options: {
    responsive: true,
    maintainAspectRatio: false,
    layout: {
      padding: {
        top: 60,
        left: 0, /* 250408 수정 */
        right: 0,
        bottom: 0,
      },
    },
    plugins: {
      legend: {
        display: false,
      },
      tooltip: {
        position: "average",
        yAlign: "bottom",
        caretPadding: 10,
        backgroundColor: "#FFECEC",
        titleColor: "#FF7A7A",
        bodyColor: "#FF7A7A",
        borderColor: "#FFCECE",
        borderWidth: 1,
        padding: 6,
        displayColors: false,
        titleFont: {
          weight: "bold",
        },
        bodyFont: {
          weight: "bold",
        },
        callbacks: {
          title: function (context) {
            const month = context[0].label;
            const year = data.chart.year[context[0].dataIndex];
            return `${year}년${month}월`;
          },
          label: function (context) {
            // 값을 천 단위 구분자로 포맷팅
            const formattedValue = context.formattedValue;
            return `${formattedValue}원`;
          },
        },
      },
    },
    scales: {
      x: {
        grid: {
          display: false, // x축 그리드 숨기기
        },
        border: {
          display: false,
        },
        ticks: {
          maxRotation: 0,
          minRotation: 0,
          autoSkip: true,
          autoSkipPadding: 10,
          color: "#000000",
          font: {
            size: 15,
          },
        },
      },
      y: { /* 250408 수정 */
        beginAtZero: true,
        border: {
          display: false,
        },
        ticks: {
          color: "#000000"
        }
      },
    },
    elements: {
      bar: {
        borderSkipped: false,
      },
    },
  },
});

watch(
  () => (data.chart = props.data),
  () => {
    //전월대비 금액 및 현재 월 매입금액 추출
    if (props.data.sysData != null) {
      data.chart.getMonth = props.data.sysData[2];
      data.chart.cnt01 = props.data.sysData[1].toLocaleString();

      if (props.data.sysData[0] > props.data.sysData[1]) {
        data.chart.flag = "A"; //감소
        data.chart.cnt02 = parseInt(
          props.data.sysData[0] - props.data.sysData[1]
        ).toLocaleString();
      } else if (props.data.sysData[0] == props.data.sysData[1]) {
        data.chart.flag = "B"; //동급
        // data.chart.cnt02 = parseInt(
        //   props.data.sysData[1] - props.data.sysData[0]
        // ).toLocaleString();
      } else if (props.data.sysData[0] < props.data.sysData[1]) {
        data.chart.flag = "C"; //증가
        data.chart.cnt02 = parseInt(
          props.data.sysData[1] - props.data.sysData[0]
        ).toLocaleString();
      }
    }
  }
);

/**********************
 * 화면 이동 모음
 *********************/
async function routerCmd() {
  router.push({
    name: "/paintpro/orderList/purchaseList",
  });
}
</script>
